import { useState } from "react"
import { useEffect } from "react"

function PointsCollector({planId, collect, measure, handlePointsDeltaUpdate, handlePointsTotalUpdate}) {

    var pointsIncrease
    var pointsTotal
    var cssClass
    if (collect === 'EPC') {
        pointsIncrease = measure.epcIncrease
        pointsTotal = measure.epcTotal
        cssClass = 'epcBand'
    } else if (collect === 'EIR') {
        pointsIncrease = measure.eirIncrease
        pointsTotal = measure.eirTotal
        cssClass = 'eirBand'
    }

    const [localDelta, setLocalDelta] = useState(pointsIncrease)
    const [localTotal, setLocalTotal] = useState(pointsTotal)

    useEffect(() => {
        if (localDelta === '') return;
        const num = Number(localDelta)
        if (Number.isInteger(num)) {
            handlePointsDeltaUpdate(localDelta)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [localDelta])

    useEffect(() => {
        if (localTotal === '') return;
        const num = Number(localTotal)
        if (Number.isInteger(num)) {
            handlePointsTotalUpdate(localTotal)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [localTotal])

    useEffect(() => {
        setLocalDelta(pointsIncrease)
        setLocalTotal(pointsTotal)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [measure])

    var band;
    if (pointsTotal >= 92) {
        band = 'A'
    } else if (pointsTotal >= 81) {
        band = 'B'
    } else if (pointsTotal >= 69) {
        band = 'C'
    } else if (pointsTotal >= 55) {
        band = 'D'
    } else if (pointsTotal >= 39) {
        band = 'E'
    } else if (pointsTotal >= 21) {
        band = 'F'
    } else {
        band = 'G'
    }

    cssClass = cssClass + band

    if (collect === 'EPC' || collect === 'EIR') {
        return (
            <>
                &#43;&nbsp;<input id={"inputIndividual_plan-" + planId + "_measure-" + measure.code} type="number" style={{border: "none", width: "46px"}} value={localDelta} onChange={e => setLocalDelta(e.target.value)} />
                &nbsp;<div className={cssClass} style={{margin: "0px", textAlign: "right", padding: "0px", display: 'inline-block', height: "100%", width: "92px"}}>{ band } ( <input id={"inputTotal_plan-" + planId + "_measure-" + measure.code} className={cssClass} type="number" style={{border: "none", width: "46px"}} value={localTotal} onChange={e => setLocalTotal(e.target.value)} /> )&nbsp;</div>
            </>
        )
    } else {
        return null;
    }

}

export default PointsCollector;